/**
 * Rate-limits a stream of (roughly increasing) timestamps to at most one
 * "flush" per interval. Returns a gate: call it with the current time and it
 * returns `true` when at least `intervalMs` has elapsed since the last flush
 * (advancing the internal marker), otherwise `false`.
 *
 * WebRTCContext uses this to keep `lastDataReceived` fresh within ~1s WITHOUT
 * calling setState — and thereby re-rendering every useWebRTC() consumer — on
 * every DataChannel message (heartbeats, binary frames, high-frequency
 * telemetry). The exact activity time is kept in a ref; this gate decides when
 * to promote it to React state.
 *
 * The marker starts at -Infinity, so the very first call always flushes
 * (activity shows up promptly after the first message, regardless of clock).
 *
 * @param {number} [intervalMs=1000] Minimum gap between flushes.
 * @returns {(now: number) => boolean}
 */
export function createTimestampThrottle(intervalMs = 1000) {
  let lastFlushAt = -Infinity;
  return function shouldFlush(now) {
    if (now - lastFlushAt >= intervalMs) {
      lastFlushAt = now;
      return true;
    }
    return false;
  };
}
